const CommentsSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.66797 4.66602H4.0013C3.64768 4.66602 3.30854 4.80649 3.05849 5.05654C2.80844 5.30659 2.66797 5.64573 2.66797 5.99935V11.9993C2.66797 12.353 2.80844 12.6921 3.05849 12.9422C3.30854 13.1922 3.64768 13.3327 4.0013 13.3327H10.0013C10.3549 13.3327 10.6941 13.1922 10.9441 12.9422C11.1942 12.6921 11.3346 12.353 11.3346 11.9993V11.3327"
        stroke="black"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 3.3334L12.6667 5.3334M13.59 4.39007C13.8526 4.12751 14.0001 3.77139 14.0001 3.40007C14.0001 3.02875 13.8526 2.67264 13.59 2.41007C13.3274 2.14751 12.9713 2 12.6 2C12.2287 2 11.8726 2.14751 11.61 2.41007L6 8.00007V10.0001H8L13.59 4.39007Z"
        stroke="black"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CommentsSvg;
